export default __webpack_public_path__ + "static/media/alert-orange.a502cb01.svg";